import { CalculatorContent } from "./CalculatorContent"

export function Calculator() {
  return <CalculatorContent />
} 